import React from "react";
import PropTypes from "prop-types";
import { FormControl, FormHelperText, Typography, Select } from "@mui/material";
import { withStyles } from "@mui/styles";

const EnhancedSelect = ({
  children,
  classes,
  label,
  caption,
  helperText,
  ...rest
}) => (
  <FormControl className={classes.formControl} fullWidth>
    {label && <Typography className={classes.label}>{label}</Typography>}
    {caption && <Typography variant="caption">{caption}</Typography>}
    <Select {...rest}>{children}</Select>
    {helperText && <FormHelperText>{helperText}</FormHelperText>}
  </FormControl>
);

EnhancedSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  caption: PropTypes.string,
};

const styles = (theme) => ({
  label: {
    fontWeight: "bold",
  },
});

export default withStyles(styles)(EnhancedSelect);
